import React, { useEffect, useState } from "react";
import back from "../Assets/Chat/material-symbols_arrow-back-rounded.svg";
import filtericon from "../Assets/Chat/Icon.svg";
import "../Style/Component/Chatlist.css";
import Chatcard from "./Chartcard.jsx";
import { getWithTokenAPI } from "../Util/Api.js";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { IssueCardSkeleton } from "./Skeleton.jsx";

const Chatlist = ({ onSelectUser }) => {
  const [chatlist, setChatList] = useState([]);
  const [refresh, SetRefresh] = useState(1);
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const adminId = auth.userId;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [filter, setFilter] = useState("newest");

  useEffect(() => {
    fetchchatlist();
  }, [token, refresh, filter]);
  const fetchchatlist = async () => {
    try {
      setLoading(true);
      const response = await getWithTokenAPI(
        token,
        `/messages/inbox?sender_id=${adminId}&filter=${filter}`,
      );
      setChatList(response);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="chatlist">
      <div className="chatlistheader">
        <img
          src={back}
          className="chatback"
          alt="backicon"
          onClick={() => navigate(-1)}
        ></img>
        <span>Messages</span>
        <div className="chatfiltericon">
          <img
            src={filtericon}
            onClick={() =>
              filter === "newest" ? setFilter("oldest") : setFilter("newest")
            }
            className={filter === "newest" ? "" : "flip"}
            alt="filter"
          ></img>
        </div>
      </div>
      <div className="chatlistbody">
        {loading ? (
          <IssueCardSkeleton />
        ) : (
          chatlist?.map((item, index) => (
            <Chatcard
              key={index}
              chat={item}
              onClick={() => {
                onSelectUser(item);
                SetRefresh((prev) => prev + 1);
              }}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Chatlist;
